import { render, staticRenderFns } from "./news_info.vue?vue&type=template&id=501d6ab7&scoped=true"
import script from "./news_info.vue?vue&type=script&lang=js"
export * from "./news_info.vue?vue&type=script&lang=js"
import style0 from "./news_info.vue?vue&type=style&index=0&id=501d6ab7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501d6ab7",
  null
  
)

export default component.exports